import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CalculateVoltageFromBattery } from '@iotv/datamodel-core';
import { ComparisonType } from '@iotv/iotv-v3-types';
import { Stack, TextField, Toolbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
export const TypeByBattery = (props) => {
    const { updateParams: setParamsInParent, keyPress, index, attKey, children, selected } = props;
    const [valueFrom, setValueFrom] = useState('0');
    const [valueTo, setValueTo] = useState('100');
    const handleFrom = (e) => {
        let value = e.target.value;
        if (value === '') {
            value = '';
        }
        const stringRegex = /[a-zA-Z]/;
        const hasLetter = stringRegex.test(value);
        if (hasLetter) {
            return;
        }
        // check .
        const regex = /\./g;
        const matches = value.match(regex);
        const dotCount = matches ? matches.length : 0;
        // const params = { type, attKey, value };
        if (dotCount < 2) {
            const sanitised = Math.min(Math.max(Number(value), 0), 100);
            setValueFrom(sanitised + '');
        }
    };
    const handleTo = (e) => {
        let value = e.target.value;
        if (value === '') {
            value = '';
        }
        const stringRegex = /[a-zA-Z]/;
        const hasLetter = stringRegex.test(value);
        if (hasLetter) {
            return;
        }
        // check .
        const regex = /\./g;
        const matches = value.match(regex);
        const dotCount = matches ? matches.length : 0;
        // const params = { type, attKey, value };
        if (dotCount < 2) {
            setValueTo(Math.min(Number(value), 100) + '');
            const sanitised = Math.max(Math.min(Number(value), 100), 0);
            setValueTo(sanitised + '');
        }
    };
    useEffect(() => {
        if (valueFrom === '' || valueTo === '' || !selected) {
            setParamsInParent(undefined, index);
        }
        else {
            setParamsInParent([
                { key: attKey, value: CalculateVoltageFromBattery(parseInt(valueFrom)), predicate: ComparisonType.GREATER_EQUAL },
                { key: attKey, value: CalculateVoltageFromBattery(parseInt(valueTo)), predicate: ComparisonType.LESS_EQUAL },
            ], index);
        }
    }, [valueFrom, valueTo, selected]);
    return (_jsxs(Toolbar, { children: [children, _jsxs(Stack, { direction: "row", spacing: 1, sx: { justifyContent: 'center', alignItems: 'center', size: 'small' }, children: [_jsx(TextField, { value: valueFrom, size: 'small', variant: 'outlined', onChange: handleFrom, onKeyDown: keyPress }), _jsx("p", { children: "to" }), _jsx(TextField, { value: valueTo, size: 'small', variant: 'outlined', onChange: handleTo, onKeyDown: keyPress }), _jsx("p", { children: "%" })] })] }));
};
